import script from "./base-code.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-code.vue?vue&type=script&setup=true&lang=ts"

import "./base-code.vue?vue&type=style&index=0&id=b095ecbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b095ecbe"]])

export default __exports__